import Alpine from 'alpinejs';

Alpine.data('stat', () => ({
    init() {
        let isInViewport = (el) => {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                (rect.top + rect.bottom)/2 <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };
        let animate = (el) => {
            if (isInViewport(el) && !this.$el.classList.contains('stat--is-animated')) {
                el.classList.add('stat--is-animated');
            }
        };

        animate(this.$el);
        window.addEventListener('scroll', () => {
            animate(this.$el);
        }, {passive: true});
    },
}));
